import { render } from "./user-booking-complete.vue?vue&type=template&id=79aba508"
import script from "./user-booking-complete.vue?vue&type=script&lang=js"
export * from "./user-booking-complete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__